module.exports = __webpack_public_path__ + "static/media/sneak_peek_background@3x.ba677bd1.png";